import React, { useEffect, useState } from "react";
import { Col, Row, Button, Card } from "react-bootstrap";
import { useContext } from "react";
import SimpleContext from "./../../context/SimpleContext";
import Date from "./../../Date/Date";
import "./Factors.css";
import config from "./../../../services/config.json";
import axios from "axios";
import { saveAs } from "file-saver";
import right from "../../img/right.png";
import { useHistory } from "react-router";

const Savabegh = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  useEffect(() => {
    context.KfPorder();
    context.CustomerOrder();
  },[]);

  const [factor, setfactor] = useState([]);
  return (
    <>
        <div
          style={{
            width: "100%",
            display: "flex",
            height: "8vh",
            position: "fixed",
            zIndex: "3",
            top: "0",
          }}
        >
          <div
            style={{
              width: "15%",
              display: "flex",
              justifyContent: "flex-start",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <img
              onClick={() => history.go(-1)}
              className="backIcon"
              src={right}
            />
          </div>
          <div
            style={{
              width: "70%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p
              style={{
                margin: "0",
                fontWeight: "bold",
                fontSize: "14px",
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                padding: "5px",
              }}
            >
              سوابق سفارشات
            </p>
          </div>
          <div style={{ width: "15%", visibility: "hidden" }}>
            <p>hiiii</p>
          </div>
        </div>
      <div style={{marginTop:'8vh'}} className="productsmain">

        <div className="sefareshatNan">
          <Row className="rows">
            <Col onClick={() => context.handleHistoryreplace("/sefareshatapi")}>
              <Row className="minirows">
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    maxWidth: "60px",
                  }}
                >
                  <img
                    src="images/Api.png"
                    alt=""
                    className="miniSafareshatImag"
                  />
                </div>
              </Row>
              <Row className="minirowwithline">
                <p style={{ margin: "0" }}>سفارشات اپی</p>
              </Row>
            </Col>
            <Col onClick={() => context.handleHistoryreplace("/sefareshatKFP")}>
              <Row className="minirows">
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    maxWidth: "60px",
                  }}
                >
                  <img
               
                    src="images/cart_failed.png"
                    alt=""
                    className="miniSafareshatImag"
                  />
                </div>
              </Row>
              <Row className="minirows">
                <p style={{ margin: "0" }}>سفارشات کیمیافرد</p>
              </Row>
            </Col>
          </Row>
        </div>

        <div className="factorMainPlace">
          {context.Freshfactors.length > 0 ? (
            context.Freshfactors.map((factor, i) => (
              <TaeedShodeHa key={i} factor={factor} i={i} />
            ))
          ) : (
            <h6 style={{ color: "grey", marginTop: "70%" }}>
              سفارشی نداشته اید!
            </h6>
          )}
        </div>
      </div>
    </>
  );
};

export default Savabegh;

export function TaeedShodeHa({ factor, i }) {
  const handleShowFactor = () => {
    async function getData() {
      const url = "https://apikala.com/api/downloadFactorUrl";
      const formData = new FormData();
      formData.append("factorID", factor.id);
      const param = {
        method: "post",
        body: formData,
      };

      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        
        saveAs(data.response.url);
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  return (
    <Card className="factors">
      <Card.Title className="factorPlaceHeader">
        <Col className="factorheaderCols">
          <p style={{ margin: "0" }}>
             فاکتور شماره{"  "}
            {i + 1}
          </p>
        </Col>
        <Col className="factorheaderCols">
          {factor.OrderDate}
          {"  "} - {factor.OrderTime}
        </Col>
      </Card.Title>
      <div className="factorRowsHoldet">
        <Row className="factorRows">
          <Col className="factorCols">
            مبلغ ناخالص: {"  "}
            {factor.Amount}
            {"  "}ریال
          </Col>
          <Col className="factorCols">
            مبلغ تخفیف: {"  "}
            {factor.Discount}
            {"  "}ریال
          </Col>
        </Row>
        <Row className="factorRows">
          <Col className="factorCols">
            مبلغ خالص: {"  "}
            {factor.AmountNut}
            {"  "}ریال
          </Col>
          <Col className="factorCols">هزینه ارسال: {"  "}رایگان</Col>
        </Row>
        <Row className="factorRows">
          <Col className="factorCols">
            تعداد ردیف فاکتور: {"  "}
            {factor.NuOfRows}
            {"  "}ردیف
          </Col>
        </Row>
      </div>
      <div className="factorFooter">
        <Button
          className="factorPlacefooter"
          onClick={() => handleShowFactor()}
        >
          دانلود فاکتور
        </Button>
      </div>
    </Card>
  );
}
